'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _countries = require('./countries.json');

var _countries2 = _interopRequireDefault(_countries);

var _provinces = require('./provinces.json');

var _provinces2 = _interopRequireDefault(_provinces);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
  Location related inconsistencies:
  Accounts have country and state/province stored as short codes. ex: country: US province: FL
  Schools have country and state/province stored as full names with the state/province property
  labeled "state" rather than "province". ex: country: United States, state: Florida
*/

var fLocations = function () {
  function fLocations() {
    _classCallCheck(this, fLocations);

    // List of countries
    // https://gist.github.com/keeguon/2310008
    this.countries = _countries2.default;

    // List of provinces
    // https://github.com/substack/provinces
    this.provinces = _provinces2.default;
  }

  // takes country long name and returns the countries states/provinces


  _createClass(fLocations, [{
    key: 'provincesByCountry',
    value: function provincesByCountry(country) {
      return this.provinces[this.countries.find(function (c) {
        return c.name === country;
      }).code];
    }
  }, {
    key: 'getCountryCode',
    value: function getCountryCode(country) {
      return this.countries.find(function (c) {
        return c.name === country;
      }).code;
    }
  }, {
    key: 'getProvinceName',
    value: function getProvinceName(provinceCode, countryCode) {
      if (!provinceCode || !countryCode) {
        return "";
      }
      var province = this.provinces[countryCode].find(function (province) {
        return province.short === provinceCode;
      });
      if (province) {
        return province.name;
      } else {
        return "";
      }
    }
  }, {
    key: 'getProvinceCode',
    value: function getProvinceCode(provinceName, countryCode) {
      if (!provinceName || !countryCode) {
        return "";
      }
      var province = this.provinces[countryCode].find(function (province) {
        return province.name === provinceName;
      });
      if (province) {
        return province.short;
      } else {
        return "";
      }
    }
  }]);

  return fLocations;
}();

exports.default = angular.module('ifeis.locations', []).service('fLocationService', fLocations);


//////////////////
// WEBPACK FOOTER
// ./locations/index.js
// module id = 140
// module chunks = 0